var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 0H2C0.895431 0 0 0.895429 0 2V98C0 99.1046 0.895429 100 2 100H98C99.1046 100 100 99.1046 100 98V2C100 0.895431 99.1046 0 98 0Z",
    fill: "#010506"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4689 49.5486C57.4899 49.489 57.5008 49.4249 57.4998 49.3588C57.4998 49.3588 57.4998 49.3588 57.4998 49.3588L56.9998 49.3668C56.9947 49.0461 56.8589 48.7013 56.5924 48.4348L44.3641 36.2065C43.8207 35.6631 42.9783 35.6631 42.4348 36.2065C41.8913 36.75 41.8913 37.5924 42.4348 38.1359L52.2706 47.9717C53.0516 48.7527 53.0516 50.019 52.2706 50.8001L42.4076 60.663C41.8641 61.2065 41.8641 62.0489 42.4076 62.5924C42.9511 63.1359 43.7935 63.1359 44.337 62.5924L57.4689 49.5486ZM57.4689 49.5486C57.4554 49.7481 57.4083 49.9443 57.3292 50.1287C57.2328 50.3536 57.0911 50.5561 56.9129 50.7236L57.4689 49.5486Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBox);
export default __webpack_public_path__ + "static/media/right-arrow-box.5659e5db59ecf5226039272f90d46826.svg";
export { ForwardRef as ReactComponent };